import { Button, Col, Collapse, Divider, Input, Radio, Row } from "antd";
import Checkbox from "antd/es/checkbox/Checkbox";
import ReactMarkdown from 'react-markdown';
import toastr from "toastr";

const { default: API } = require("API");
const { useState } = require("react");

const style = {
    display: 'flex',
    flexDirection: 'column',
};

function Quiz({ data, setQuiz, onChange, disable=false }) {
    return (data.correct_answers.length === 1) ? <Radio.Group
        style={style}
        onChange={(e) => {
            if (!data.student_answer) {
                data.student_answer = {};
            }
            data.student_answer.answers = [e.target.value]
            setQuiz(quiz => JSON.parse(JSON.stringify(quiz)))
            onChange && onChange([e.target.value]);
        }}
        value={data.student_answer?.answers && data.student_answer?.answers[0]}
        options={data.answers.map((item, index) => ({
            value: index,
            label: item,
            className: "quiz-label" + (data.correct_answers.includes(index) ? " correct-option" :
            (data.correct_answers[0] !== -1 && data.student_answer?.answers?.includes(index)) ?
            " wrong-option" : ""),
            style: {
                padding: 3,
            }
        }))}
        disabled={disable}
    /> : <Checkbox.Group 
        style={style}
        onChange={(e) => {
        if (!data.student_answer) {
            data.student_answer = {};
        }
        data.student_answer.answers = e
        setQuiz(quiz => JSON.parse(JSON.stringify(quiz)))
        onChange && onChange(e);
    }}
        value={data.student_answer?.answers}
        options={data.answers.map((item, index) => ({
            value: index,
            label: item,
            className: "quiz-label" + (data.correct_answers.includes(index) ? " correct-option" :
            (data.correct_answers[0] !== -1 && data.student_answer?.answers?.includes(index)) ?
            " wrong-option" : ""),
            style: {
                padding: 3,
            },
        }))}
        disabled={disable}
    />
}

function Essay({ data, setExercises, token, lesson_id }) {
    const [loading, setLoading] = useState(false)
    const [edited, setEdited] = useState(false);
    const getFeedBack = () => {
        setLoading(true)
        API.post("get-exercises/", {
            token: token, exercise_id: data.id, answer: data.student_answer.answer, lesson_id: lesson_id
        })
            .then(res => {
                data.student_answer = res.data;
                setExercises(exercises => JSON.parse(JSON.stringify(exercises)));
                setEdited(false);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            })
    }
    return <>
        <Input.TextArea value={data.student_answer?.answer} onChange={e => {
            setEdited(true);
            if (!data.student_answer) {
                data.student_answer = {};
            }
            data.student_answer.answer = e.target.value;
            setExercises(exercises => JSON.parse(JSON.stringify(exercises)));
        }} />
        <Button type="primary" loading={loading} disabled={!edited} onClick={getFeedBack}>
            Chấm điểm
        </Button>
        {data.student_answer?.feedback ? <div className="div-essay-feedback">
            <b>Đánh giá:</b>
            <ReactMarkdown>
                {data.student_answer?.feedback?.evaluate}
            </ReactMarkdown>
            <b>Gợi ý:</b>
            <ReactMarkdown>
                {data.student_answer?.feedback?.suggest}
            </ReactMarkdown>
        </div> : null}
    </>
}

const quizStatus = {
    [null]: <span style={{ color: "blue" }}>(Chưa làm)</span>,
    [true]: <span style={{ color: "green" }}>(Đúng)</span>,
    [false]: <span style={{ color: "red" }}>(Sai)</span>,
}

function _StudentExercises({ quizzes, setQuizzes, essays, setEssays, lesson_id }) {
    const [submitting, setSubmitting] = useState(false);
    return <Row gutter={10}>
        <Col span={24} lg={12}>
            <Divider>
                Trắc nghiệm
            </Divider>
            <div style={{ position: "relative" }}>
                <Collapse accordion items={quizzes.map(item => ({
                    key: item.id,
                    label: <>{item.question} - {quizStatus[item.correct]}</>,
                    children: <Quiz data={item} setQuiz={setQuizzes} />
                }))} />
                <Button type="primary" loading={submitting} onClick={() => {
                    setSubmitting(true);
                    API.post("submit-quiz/", {
                        lesson_id: lesson_id, quizzes: quizzes
                    })
                        .then(res => {
                            setQuizzes(res.data);
                        })
                        .catch(error => {
                            console.log(error);
                        })
                        .finally(() => {
                            setSubmitting(false);
                        })
                }} style={{ position: "absolute", top: 8, right: 10 }}>
                    Nộp bài quiz
                </Button>
            </div>
        </Col>
        <Col span={24} lg={12}>
            <Divider>
                Tự luận
            </Divider>
            <Collapse accordion items={essays.map(item => ({
                key: item.id,
                label: item.question,
                children: <Essay data={item} setExercises={setEssays} lesson_id={lesson_id} />
            }))} />
        </Col>
    </Row>
}

export default function StudentExercises({ quizzes, setQuizzes, essays, setEssays,
    studentQuizzes, setStudentQuizzes, studentEssays, setStudentEssays, lesson_id }) {
    const [generating, setGenerating] = useState(false);
    const [realExercises, setRealExercises] = useState(false);
    return <>
        <_StudentExercises quizzes={quizzes} setQuizzes={setQuizzes}
            essays={essays} setEssays={setEssays} lesson_id={lesson_id} />
        {(studentQuizzes.length > 0 || studentEssays.length > 0) &&
            <><Divider>Bài tập của bạn</Divider>
                <_StudentExercises quizzes={studentQuizzes} setQuizzes={setStudentQuizzes}
                    essays={studentEssays} setEssays={setStudentEssays} lesson_id={lesson_id} />
            </>}
        <Divider />
        <div style={{ textAlign: "center" }}>
            <Button type="primary" loading={generating} disabled={generating} onClick={() => {
                setGenerating(true);
                API.post("/get-student-exercises/", { lesson_id: lesson_id, real_exercises: realExercises })
                    .then(res => {
                        for (const q of res.data.result.quizzes) {
                            q.correct = null;
                            q.student_answer = null;
                        }
                        for (const e of res.data.result.essays) {
                            e.student_answer = null;
                        }
                        setStudentQuizzes(res.data.result.quizzes);
                        setStudentEssays(res.data.result.essays);
                    })
                    .catch(error => {
                        if (error?.response?.status === 400 &&
                            error?.response?.data?.error === "Please correct all quizzes first") {
                            toastr.error("Vui lòng hoàn thành đúng toàn bộ bài tập quiz");
                            return;
                        }
                        if (error?.response?.status === 400 &&
                            error?.response?.data?.error === "Please do all essays first") {
                            toastr.error("Vui lòng hoàn thành toàn bộ bài tập tự luận");
                            return;
                        }
                        console.log(error);
                    })
                    .finally(() => {
                        setGenerating(false);
                    })
            }}>
                Tạo thêm bài tập
            </Button>
            <Checkbox id="real_exercises" checked={realExercises} onChange={(e)=>setRealExercises(e.target.checked)} style={{margin: 3}}/>
            <label htmlFor="real_exercises" style={{ cursor: "pointer" }}>Bài tập thực tế</label>
        </div>
    </>
}


export { Essay, Quiz }